<template>
    <v-data-table v-bind="{ items, headers }" mobile-breakpoint="10000" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined" style="flex: 1 0 auto; position: relative" v-if="!isOrderTypeStock">
        <template #top> <div class="table-label px-1 white">배송정보</div> </template>
        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
    </v-data-table>
</template>

<script>
import { ORDER_TYPES } from "@/assets/variables";
const headers = [
    { text: "수취인", value: "receiver.name" },
    {
        text: "주소",
        value: "receiver",
        formatter: ({ postcode, address1, address2 } = {}) => {
            let address = "";
            if (postcode) address += `[${postcode}]`;
            if (address1) address += ` ${address1}`;
            if (address2) address += ` ${address2}`;
            return address;
        },
    },
    { text: "연락처", value: "receiver.phone" },
    { text: "요청사항", value: "requestMessage" },
].map((item, index, array) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-"), cellClass: "caption", divider: index != array.length - 1 }));

export default {
    props: {
        order: { type: Object, default: () => {} },
    },
    data: () => ({
        headers,
    }),
    computed: {
        items() {
            return [this.order];
        },
        isOrderTypeStock() {
            return this.order?.type == ORDER_TYPES.STOCK.value;
        },
    },
};
</script>

<style lang="scss" scoped>
.table-label {
    position: absolute;
    left: 0;
    bottom: 100%;
    transform: translateY(50%) scale(0.75);

    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
}
::v-deep {
    .v-data-table__mobile-row {
        padding: 4px 16px !important;
        &,
        & * {
            height: auto !important;
            min-height: auto;
            font-size: 12px;
            font-weight: normal;
        }
        &:first-child {
            margin-top: 12px;
        }
        &:last-child {
            margin-bottom: 12px;
        }
    }
}
</style>
